module.exports = __webpack_public_path__ + "media/whats_your_status_series/step-05-8897b0d0.jpg";